import axios from 'axios'

const baseURL = process.env.VUE_APP_API_ENDPOINT

import store from '@/store'
import router from '@/router'
import { VueCookieNext } from 'vue-cookie-next'

const instance = axios.create({
  baseURL,
  withCredentials: true
})

instance.interceptors.response.use(
  response => response,
  async error => {
    if (window.navigator.onLine) {
      const checkUrl = 'URLが間違っていないかご確認ください。'

      const errors = error.response.data.errors
      errors.map((error: any) => {
        switch (error.error_code) {
        case 1:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: 'アカウントIDかパスワードが間違っています。'
          })
          break
        case 41:
          VueCookieNext.removeCookie('user_id')
          router.push({ name: 'login' })

          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: '認証情報がありません。\nログインしてご利用ください。'
          })
          break
        case 1000:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: 'コード、リーグ・ブロック名を入力してください。'
          })
          break
        case 2001:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: 'このアカウントIDは既に登録されています。\n他のIDを利用してください。'
          })
          break
        case 2006:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: `試合が存在しません。\n${checkUrl}`
          })
          break
        case 3002:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: `大会イベントが存在しません。\n${checkUrl}`
          })
          break
        case 3003:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: `シーズンが存在しません。\n${checkUrl}`
          })
          break
        case 3005:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: `チームが存在しません。\n${checkUrl}`
          })
          break
        case 3006:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: `エントリーチームが存在しません。\n${checkUrl}`
          })
          break
        case 3007:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: `選手が存在しません。\n${checkUrl}`
          })
          break
        case 3008:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: `グループが存在しません。\n${checkUrl}`
          })
          break
        default:
          store.dispatch('addFlashMessage', {
            type: 'danger',
            message: 'サーバーエラーが発生しました。\nしばらく経ってから、もう一度お試しください。'
          })
          break
        }
      })
    } else {
      store.dispatch('addFlashMessage', {
        type: 'danger',
        message: 'インターネットに接続されていません。\n電波状況をご確認ください。'
      })
    }
  }
)

export default instance